import { render, staticRenderFns } from "./AppRegistrationLayout.vue?vue&type=template&id=f9974a46&scoped=true&"
import script from "./AppRegistrationLayout.vue?vue&type=script&lang=js&"
export * from "./AppRegistrationLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppRegistrationLayout.vue?vue&type=style&index=0&id=f9974a46&scoped=true&lang=scss&"
import style1 from "./AppRegistrationLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9974a46",
  null
  
)

export default component.exports